export default "__VITE_ASSET__DnqMYBoJ__"